import { POST, postFile, GET } from "../../index";

export const getKey = (param) => POST("/v1/Key/getKey", param);
export const insertKey = (param) => POST("/v1/Key/insertKey", param);
export const selectTerminalAll = (param) => POST("/v1/terminal/selectTerminalAll", param);
